var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLamp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 52,
    viewBox: "0 0 50 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 38.75V27.5938M25 27.5938C26.0791 27.5938 27.1262 27.4544 28.125 27.1922M25 27.5938C23.9209 27.5938 22.8738 27.4544 21.875 27.1922M29.6875 43.0838C28.1691 43.3776 26.6022 43.5313 25 43.5313C23.3978 43.5313 21.8309 43.3776 20.3125 43.0838M28.125 48.1467C27.098 48.2563 26.0554 48.3125 25 48.3125C23.9446 48.3125 22.902 48.2563 21.875 48.1467M29.6875 38.75V38.3427C29.6875 36.254 31.0589 34.4682 32.8301 33.4199C37.4907 30.6617 40.625 25.5167 40.625 19.625C40.625 10.823 33.6295 3.6875 25 3.6875C16.3706 3.6875 9.375 10.823 9.375 19.625C9.375 25.5167 12.5093 30.6617 17.1699 33.4199C18.9411 34.4682 20.3125 36.254 20.3125 38.3427V38.75",
    stroke: "#90CC61",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLamp);
export default __webpack_public_path__ + "static/media/lamp.d7b2d51e27fcf1dd0215ae51d23975a6.svg";
export { ForwardRef as ReactComponent };